import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from "@angular/router";
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';

@Component({
  selector: 'app-network-protocols',
  standalone: true,
  imports: [CommonModule, RouterLink, FeatureHero],
  templateUrl: './network-protocols.html',
  styleUrl: './network-protocols.scss',
})
export class NetworkProtocols implements OnInit, OnDestroy {
  slides = [
    {
      title: 'Configuration and Management',
      description:
        'Network topology helps in the configuration and management of network devices. By understanding the network’s structure, administrators can determine how devices should be configured and how they interact.',
    },
    {
      title: 'Visualization',
      description:
        'It visually represents the network infrastructure, allowing IT administrators and technicians to understand and navigate the network layout easily.',
    },
    {
      title: 'Performance Monitoring',
      description:
        'Network topology helps in monitoring the performance of the network. By analyzing the topology, administrators can identify potential points of failure or traffic bottlenecks.',
    },
    {
      title: 'Fault Detection',
      description:
        'Understanding the network’s topology is crucial for detecting and isolating network faults and identifying affected devices or segments.',
    },
  ];

  activeIndex = 0;
  intervalId: any = null;

  ngOnInit(): void {
    this.startInterval();
  }

  ngOnDestroy(): void {
    this.stopInterval();
  }

  setActive(index: number): void {
    this.activeIndex = index;
  }

  nextSlide(): void {
    this.activeIndex =
      this.activeIndex < this.slides.length - 1
        ? this.activeIndex + 1
        : 0;
  }

  startInterval(): void {
    if (!this.intervalId) {
      this.intervalId = setInterval(() => {
        this.nextSlide();
      }, 4000);
    }
  }

  stopInterval(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  get imageSrc(): string {
    return `/assets/img/feature-pages/infraon-ims/network-topology/nms-network-topology-slider-img-${this.activeIndex + 1}.svg`;
  }
}